import { isNumber, isBoolean, isObject } from 'ramda-adjunct';
import { always, cond, mapObjIndexed, T } from 'ramda';

export const normalizeVariables = (variables) => {
  const getVariableType = (value) => cond([
    [isBoolean, always('boolean')],
    [isNumber, always('number')],
    [T, always('text')]
  ])(value);

  return mapObjIndexed((value) => {
    if (isObject(value)) return value;
    return {
      value,
      type: getVariableType(value)
    };
  })(variables);
};
